import ProductCtaCardSkeleton from './ProductCtaCardSkeleton';

export default function ProductPageSkeleton() {
  return (
    <>
      <title>Product Skeleton Screen</title>

      <div className="wrap product-header border-bottom py-3 py-lg-4 mb-3">
        <div className="container-fluid but-fixed">
          <div className="row justify-content-between">
            <header className="col-9 col-lg-10">
              <h1 className="mb-0">
                <span className="animated-placeholder height-lg w-70"></span>
              </h1>
            </header>
          </div>
        </div>
      </div>
      <div className="container-fluid but-fixed py-0 mb-lg-4">
        <div className="row justify-content-center">
          <div className="col-12 d-none d-lg-block mb-3">
            <nav aria-label="breadcrumb">
              <span className="animated-placeholder height-sm" style={{ width: '150px' }}></span>
            </nav>
          </div>

          <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4 order-lg-1 my-2 mb-sm-3">
            <ProductCtaCardSkeleton />
          </div>

          <div className="col-12 col-lg-7 col-xl-8 my-3 order-lg-0">
            <p>
              <span className="animated-placeholder w-100"></span>
              <span className="animated-placeholder w-100"></span>
              <span className="animated-placeholder w-80"></span>
              <span className="animated-placeholder w-60"></span>
            </p>
            <p>
              <span className="animated-placeholder w-100"></span>
              <span className="animated-placeholder w-80"></span>
              <span className="animated-placeholder w-60"></span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
